import { apiRequest } from "./client";

export async function fetchChecklists(
  folderId,
  page = 1,
  size = 20,
  searchQuery = "",
  searchType = "all"
) {
  const effectiveFolderId =
    folderId === null || folderId === undefined ? "unclassified" : folderId;
  const params = new URLSearchParams({
    folder_public_id: effectiveFolderId,
    page: page,
    size: size,
  });
  if (searchQuery) {
    params.append("search_query", searchQuery);
    params.append("search_type", searchType);
  }
  const response = await apiRequest(`/api/v1/checklists?${params.toString()}`);
  return response.json();
}

export async function fetchChecklist(checklistPublicId) {
  const response = await apiRequest(`/api/v1/checklists/${checklistPublicId}`);
  return response.json();
}

export async function updateChecklistTask(
  checklistPublicId,
  taskPublicId,
  updatedData
) {
  return await apiRequest(
    `/api/v1/checklists/${checklistPublicId}/tasks/${taskPublicId}`,
    {
      method: "PATCH",
      body: JSON.stringify(updatedData),
    }
  );
}

export async function updateChecklist(checklistPublicId, updatedData) {
  return await apiRequest(`/api/v1/checklists/${checklistPublicId}`, {
    method: "PATCH",
    body: JSON.stringify(updatedData),
  });
}

export async function deleteChecklistLogically(checklistPublicId) {
  const response = await apiRequest(`/api/v1/checklists/${checklistPublicId}`, {
    method: "DELETE",
  });

  if (!response.ok && response.status !== 204) {
    const errorData = await response.text();
    throw new Error(`サーバーエラー: ${response.status}. ${errorData}`);
  }

  return response;
}

export async function deleteMultipleChecklists(checklistPublicIds) {
  const response = await apiRequest(`/api/v1/checklists/bulk-delete`, {
    method: "POST",
    body: JSON.stringify({
      checklist_public_ids: checklistPublicIds,
    }),
  });

  if (!response.ok) {
    const errorData = await response.text();
    throw new Error(`サーバーエラー: ${response.status}. ${errorData}`);
  }

  return response;
}

export async function sendMailRequest(checklistName, assigneeName) {
  const response = await apiRequest(`/api/v1/mail_send_requests`, {
    method: "POST",
    body: JSON.stringify({
      checklist_name: checklistName,
      assignee_name: assigneeName,
    }),
  });

  if (!response.ok) {
    const errorData = await response.text();
    throw new Error(`サーバーエラー: ${response.status}. ${errorData}`);
  }

  return response.json();
}
